
import MachinationsLightPage from '~/domain/pages/MachinationsLightPage'
import {PageData} from "@interfaces/PageDataTypes";

export default MachinationsLightPage.extend({
  name: 'TermsAndConditionsPage',
  layout: 'machinations',
  extends: MachinationsLightPage,
  head() {
    // @ts-ignore
    const pageHead = this.pageHead()
    const pageData = this.pageData as PageData
    const yoastDescription = pageData?.yoast_head_json?.description
    return {
      ...pageHead,
      title: `Terms and Conditions`,
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          content: 'Terms and Conditions',
        },
        {
          hid: 'description',
          name: 'description',
          content: yoastDescription,
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: yoastDescription,
        },
        ...pageHead?.meta,
      ],
    }
  },
  async asyncData(context) {
    const { store } = context

    await store.dispatch('common/setupPageLight', { context })
    const pageData = await store.dispatch('wp/fetchPageBySlug', {
      context,
      slug: 'terms-and-conditions',
    })
    return {
      pageData,
    }
  },
  computed: {
    wpContent() {
      return this.$store.state.wp.pageContent
    },
  },
})
